export default class PropertyTemplate {
  constructor(property) {
    this.property = property;
    this.imageUrl = this.property.property_thumb_image ?
      this.property.property_thumb_image.url : 'http://placehold.it/200';
    this.numSpacesAvailable = this.property.num_spaces_available;
    // this.numOutlotsAvailable = this.property.num_outlots_available;
  }

  renderTemplate() {
    return `
      <div class="property-archive__property__wrapper">

        <div class="property-archive__property">

          <div class="property-archive__property__image" style="background-image: url(${this.imageUrl})"><a href="${this.property.entry_url}"></a></div>

          <div class="property-archive__property__text">
            <div class="property-archive__property__title"><a href="${this.property.entry_url}">${this.property.name}</a></div>
            <div class="property-archive__property__msa">MSA: ${this.property.msa || 'NO MSA'}</div>
            <div class="property-archive__property__gla">${this.property.gla.toLocaleString()} <span>GLA</span></div>
            <div class="property-archive__property__spaces-available">Spaces Available: ${this.numSpacesAvailable}</div>`
            // <div class="property-archive__property__outlots-available">Outlots Available: ${this.numOutlotsAvailable}</div>

          +`</div>
          <div class="property-archive__property__contact">
            <img loading="lazy" src="/static/images/letter.svg" alt="Contact">
            <a href="${this.property.entry_url}#contact-leasing">Contact Leasing</a>
          </div>

        </div>
      </div>
    `
  }
}



// WEBPACK FOOTER //
// ./web/src/app/javascripts/components/properties-app/PropertyTemplate.jsx